import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getRefundPlans} from '../../services/getRefundPlans';
import {UseGetRefundPlansQueryProps} from './types';

export const useGetRefundPlansQuery = ({
	enabled = false,
	userCode = '',
	page,
	limit,
}: UseGetRefundPlansQueryProps) =>
	useQuery({
		queryKey: [QUERY_KEYS.REFUND_PLANS, userCode, page, limit],
		queryFn: async () => getRefundPlans({userCode, page, limit}),
		enabled: enabled && !!userCode,
	});
